export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 订单列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    MARKET_ALL: function MARKET_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/market/index',
        method: 'post',
        data: query
      });
    },

    /**
       * @description 新闻创建
       * @description http://yapi.xiya.vip/project/11/interface/api/80
       */
    MARKET_CREATE: function MARKET_CREATE(data) {
      return request({
        url: '/api/market/create',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 字典详情
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    MARKET_DETAIL: function MARKET_DETAIL(id) {
      return request({
        url: '/api/market/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
       * @description 字典编辑
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    MARKET_UPDATE: function MARKET_UPDATE(data) {
      return request({
        url: '/api/market/update',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 新闻删除
       * @description http://yapi.xiya.vip/project/11/interface/api/90
       */
    MARKET_DELETE: function MARKET_DELETE(id) {
      return request({
        url: '/api/market/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    },
    MARKET_SYNC: function MARKET_SYNC(data) {
      return request({
        url: '/api/market/sync',
        method: 'post',
        data: data
      });
    }
  };
});